module.exports = __webpack_public_path__ + "static/media/seated_rep.b62290bd.png";